  <div class="headr-div">
    <h1 mat-dialog-title>
        {{data.chat.isSms?'Sms Information':'Email Information'}}
      </h1>
      <button mat-icon-button mat-dialog-close class="close-icon" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
  </div>
  <div *ngIf="!data.chat.isSms">
      <div mat-dialog-content>
        <div class="info-row">
          <div><strong>To:</strong> {{ data.chat.to }}</div>
          <div><strong>From:</strong> {{ data.chat.from }}</div>
        </div>
        <div class="info-row">
          <div class="half-width"><strong>Cc:</strong> {{ data.chat.cc }}</div>
          <div class="half-width"><strong>Bcc:</strong> {{ data.chat.bcc }}</div>
        </div>
        <div class="info-row">
          <div><strong>Subject:</strong> {{ data.chat.subject }}</div>
          <div><strong>Direction:</strong> {{ data.chat.direction }}</div>
        </div>
        <div class="info-row" *ngIf="data.chat.seen">
          <div class="half-width"><strong>Seen at:</strong> {{ data.chat.seen_at | date:'short' }}</div>
          <div class="half-width"><strong>Status:</strong> Seen</div>
        </div>
        <div class="content-section">
          <strong>Content:</strong>
          <div [innerHTML]="safeContent"></div>
        </div>
        
        <div class="created-section" *ngIf="data.chat.direction === 'sent'">
          <p>
            <strong>Created:</strong>
            <ng-container *ngIf="data?.chat?.createdBy; else systemCreated">
              {{ data.chat.createdBy.name + ' ' + data.chat.createdBy.lastName }}
            </ng-container>
            <ng-template #systemCreated>
              System
            </ng-template>
            at {{ data.chat.created_at | date: 'short' }}
          </p>
        </div>
        
        <div class="created-section" *ngIf="data.chat.direction=='received'">
          <p><strong>Created:</strong> by {{data?.lead?.name}} {{data?.lead?.lastName}} at {{ data.chat.created_at | date: 'short' }}</p>
        </div>
      </div>


           <!-- Attachments display when expanded (unchanged) -->
     <app-display-file 
     *ngIf="data?.chat?.attachments?.length>0" 
     [isAlreadySent]="true" 
     [attachedFiles]="[]" 
     [fixedFiles]="data?.chat?.attachments">
   </app-display-file>

   
      <div mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
      </div>
  </div>


  <div *ngIf="data.chat.isSms">
    <div mat-dialog-content>
      <div class="info-row">
        <div><strong>To:</strong> {{ data.chat.toPhoneNumber }}</div>
        <div><strong>From:</strong> {{ data.chat.fromPhoneNumber }}</div>
      </div>
      <div class="info-row">
        <div><strong>Direction:</strong> {{ data.chat.direction }}</div>
      </div>
      <div class="content-section">
        <strong>Content:</strong>
        <div [innerHTML]="safeContent"></div>
      </div>
      <div class="created-section" *ngIf="data.chat.direction === 'sent'">
        <p>
          <strong>Created:</strong>
          <ng-container *ngIf="data?.chat?.createdBy; else systemCreated">
            {{ data.chat.createdBy.name + ' ' + data.chat.createdBy.lastName }}
          </ng-container>
          <ng-template #systemCreated>
            System
          </ng-template>
          at {{ data.chat.created_at | date: 'short' }}
        </p>
      </div>
      <div class="created-section" *ngIf="data.chat.direction=='received'">
        <p><strong>Created:</strong> by {{data?.lead?.name}} {{data?.lead?.lastName}} at {{ data.chat.created_at | date: 'short' }}</p>
      </div>
    </div>


         <!-- Attachments display when expanded (unchanged) -->
         <app-display-file 
         *ngIf="data?.chat?.attachments?.length>0" 
         [isAlreadySent]="true" 
         [attachedFiles]="[]" 
         [fixedFiles]="data?.chat?.attachments">
       </app-display-file>


    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>
</div>

